import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'
import styled from 'styled-components'
import {
  Form,
  FormGroup,
  Label,
  Input,
  CustomInput,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col,
} from 'reactstrap'
import Select from 'react-select'
import { status } from '../../constants'
import moment from '../../lib/moment.js'

const url = 'https://www.materialui.co/materialIcons/navigation/cancel_black_192x192.png'

class TeamForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: '1',
    }
  }
  checkDivisionCode(id) {
    const object = _.get(this.props, 'list')
    if (object) {
      for (let i = 0; i < object.length; i++) {
        if (object[i]._id === id) {
          return {
            label: `${_.get(object[i], 'division_code')} - ${_.get(object[i], 'name')}`,
            division_code: _.get(object[i], '_id'),
          }
        }
      }
    }
    return { label: 'Choose Division Name', division_code: '' }
  }
  createDivisionList() {
    const object = _.get(this.props, 'list')
    const temp = [{ label: 'Choose Division Name', division_code: '' }]
    if (object) {
      object.map((ob) => {
        temp.push({
          label: `${_.get(ob, 'division_code')} - ${_.get(ob, 'name')}`,
          division_code: _.get(ob, '_id'),
        })
        return ob
      })
    }
    return temp
  }
  render() {
    return (
      /* eslint no-underscore-dangle: 0 */
      <Background>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={ classnames({ active: this.state.activeTab === '1' }) }
              onClick={ () => {} }
            >
              Team Information
            </NavLink>
          </NavItem>
          <Image
            src={ url }
            onClick={ _.get(this.props, 'confirm') === 'teamForm' ? this.props.cancelForm : this.props.showDiscard }
          />
        </Nav>
        <TabContent activeTab={ this.state.activeTab } >
          <TabPane tabId="1">
            <Row>
              <Col sm="12">
                <Form>
                  <FormGroup>
                    <ContainerInTab>
                      <FormGroup>
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }>
                            <Label >Start Date</Label>
                          </Col>
                          <Col sm={ 9 }>
                            <InputFieldDate
                              autoComplete='off'
                              name="start_date"
                              type="date"
                              disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                              value={ moment(_.get(this.props, 'start_date')).format('YYYY-MM-DD') }
                              onChange={ this.props.handleInput }
                            />
                          </Col>
                        </Row>
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }>
                            <Label>Division</Label>
                          </Col >
                          <Col sm={ 9 }>
                            {
                              <SelectInputField
                                styles={ customStyles }
                                name='division_id'
                                isDisabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                                value={ this.checkDivisionCode(this.props.division_id) }
                                options={ this.createDivisionList() }
                                onChange={ this.props.handleDivision }
                              />
                            }
                          </Col>
                        </Row>
                      </FormGroup>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Team ID</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="team_code"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Team Code"
                            value={ _.get(this.props, 'team_code') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      <Row style={ { marginTop: 10 } }>
                        <Col sm={ 3 }>
                          <Label >Team Name</Label>
                        </Col>
                        <Col sm={ 9 }>
                          <InputField
                            name="team"
                            disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                            placeholder="Enter Team Name"
                            value={ _.get(this.props, 'team') }
                            onChange={ this.props.handleInput }
                          />
                        </Col>
                      </Row>
                      {
                        _.get(this.props, 'create') === undefined &&
                        <Row style={ { marginTop: 10 } }>
                          <Col sm={ 3 }><Label>Status</Label></Col>
                          <Col sm={ 9 }>
                            {
                              <CustomInputField
                                type="select"
                                id="is_active"
                                name="is_active"
                                disabled={ !_.get(this.props, 'edit') && _.get(this.props, 'create') === undefined }
                                value={ this.props.is_active }
                                onChange={ this.props.handleChange }
                              >
                                {
                                  status.map((s, key) => <option key={ key } value={ s.value }>{ s.label }</option>)
                                }
                              </CustomInputField>
                            }
                          </Col>
                        </Row>
                      }
                    </ContainerInTab>
                  </FormGroup>
                  <Right>
                    { _.get(this.props, 'button') }
                  </Right>
                </Form>
              </Col>
            </Row>
          </TabPane>
        </TabContent>
      </Background>
    )
  }
}

TeamForm.propTypes = {
  cancelForm: PropTypes.func.isRequired,
  showDiscard: PropTypes.func.isRequired,
  handleInput: PropTypes.func.isRequired,
}

export default TeamForm

const Right = styled.div`
  background-color: white;
  padding: 10px;
  text-align: right;
`

const Background = styled.div`
  background-color: white;
  padding: 10px;
  font-family: 'Gotham-Bold' !important;
  font-size: 14px ;
`
const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const SelectInputField = styled(Select)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const InputFieldDate = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
    float: right;
    ::-webkit-inner-spin-button {
      display: none;
      -webkit-appearance: none;
    }

`
const ContainerInTab = styled(Container)`
    /* overflow-y: scroll;
    max-height: calc(100vh - 220px); */
`
const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`

const Image = styled.img`
width: 20px;
height: 20px;
position: absolute;
right: 10px;
`
const customStyles = {
  option: (base, state) => ({
    ...base,
    background: state.isFocused ? '#007bff' : "#FFFFFF",
    color: state.isFocused ? 'white' : 'black',
  }),
  menu: base => ({
    ...base,
    background: "#FFFFFF",
    padding: 0,
  }),
  control: base => ({
    ...base,
    background: "#FFFFFF",
  }),

}



// WEBPACK FOOTER //
// ./src/components/team/index.js